export const GEOGRAPHICZONES = 'GEOGRAPHICZONES';

export function getGeographicZones(geographicZones) {
    return {type: GEOGRAPHICZONES, geographicZones}
}